import { fromJS } from 'immutable';

import { fetchTaskFileConfigsRoutine } from '../routines';

const initialState = fromJS({
  taskfileconfigs: {},
  loading: false,
});

export default function (state = initialState, action) {
  // console.log('action',action);
  switch (action.type) {
    case fetchTaskFileConfigsRoutine.SUCCESS:
      return state.set('taskfileconfigs', fromJS(action.payload.response));
    case fetchTaskFileConfigsRoutine.FAILURE:
      return state.setIn(['taskfileconfigs', 'loading'], false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/taskfileconfigs.js